<template>
    <div class="article-list grid grid__base" @click="loadNext">
        <div class="grid--container">
            <div class="article-list--row grid--row">
                <slot/>
                <a class="article-list--col article-list--item grid--col"
                        v-for="(item, idx) in articleItems"
                        :key="idx"
                        :href="item.link.path">
                    <article-preview v-bind="item"/>
                </a>
            </div>

            <div class="article-list--row grid--row" v-if="canLoadNext && fetchUrl">
                <div class="grid--col">
                    <intersection-observer-component @intersect-enter="onIntersectEnter">
                        <dat-loader/>
                    </intersection-observer-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ArticlePreview from 'framework/global-components/dyn/article-preview/article-preview';
    import Axios from 'util/service';
    import { IntersectionObserverComponent } from '@dreipol/vue-ui';
    import SpinningLoader from 'framework/components/loaders/spinning-loader/spinning-loader';
    import DatLoader from 'framework/components/dat-loader/dat-loader';

    export default {
        components: { DatLoader, SpinningLoader, ArticlePreview, IntersectionObserverComponent },
        props: {
            /** @type {IArticlePreview[]} */
            items: {
                type: Array,
                default: () => [],
            },

            fetchUrl: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                /** @type {IArticlePreview[]} */
                articleItems: [],
                page: 0,
                canLoadNext: true,
                isLoading: false,
            };
        },

        methods: {
            onIntersectEnter() {
                this.loadNext();
            },

            loadNext() {
                if (!this.canLoadNext || this.isLoading) {
                    return;
                }

                this.isLoading = true;
                Axios.get(this.fetchUrl, { params: { page: this.page } })
                    .then(({ data }) => {
                        this.isLoading = false;
                        this.page++;
                        this.articleItems.push(...data);
                        if (data.length === 0) {
                            this.canLoadNext = false;
                        }
                    })
                    .catch(() => {
                        this.isLoading = false;
                        this.canLoadNext = false;
                    });// eslint-disable-line vue/script-indent
            },
        },

        mounted() {
            this.articleItems.push(...this.items);
        },
    };
</script>
